/* Keep interactive sections usable when Shopify replaces, removes or selects blocks. */
(() => {
  const mobile = matchMedia('(max-width: 760px)');
  const visible = node => !!node && node.getClientRects().length > 0 && getComputedStyle(node).display !== 'none';
  function syncDisclosures(scope = document) {
    scope.querySelectorAll('[data-responsive-disclosure]').forEach(details => {
      const compact = mobile.matches && !!details.closest('.mobile-confidence-accordion');
      if (details.dataset.compact !== String(compact)) {
        details.open = !compact;
        details.dataset.compact = String(compact);
      }
    });
  }
  function syncLinks() {
    document.querySelectorAll('[data-product-jump-links] a').forEach(link => {
      const target = document.getElementById(link.hash.slice(1));
      link.hidden = !target || !visible(target.closest('.shopify-section'));
    });
    document.querySelectorAll('a[href="#ProductForm"]').forEach(link => {
      const form = document.getElementById('ProductForm');
      link.hidden = !form || !visible(form);
    });
    document.querySelectorAll('a[href="#WriteReview"],[data-review-topic]').forEach(link => {
      const form = document.querySelector('.write-review');
      link.hidden = !form || !visible(form);
    });
  }
  function init(scope = document) { syncDisclosures(scope); syncLinks(); }
  init();
  mobile.addEventListener('change', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncLinks));
  document.addEventListener('shopify:section:reorder', syncLinks);
  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest('.shopify-section') || document;
    const id = event.detail?.blockId;
    const selected = event.target.closest('[data-editor-block]') || (id && section.querySelector('[data-editor-block="' + CSS.escape(id) + '"]'));
    if (!selected) return;
    const panel = selected.closest('[role="tabpanel"]');
    if (panel) section.querySelector('[data-tab="' + CSS.escape(panel.id) + '"]')?.click();
    const answer = selected.closest('[data-return-answer]');
    if (answer) {
      const select = section.querySelector('[data-return-situation]');
      if (select) { select.value = answer.dataset.returnAnswer; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    const details = selected.closest('details');
    if (details) details.open = true;
    if (visible(selected)) selected.scrollIntoView({ behavior: 'instant', block: 'nearest' });
  });
})();
